import { OctetString } from "@peculiar/asn1-schema";
import { SignedCertificateTimestamp } from "./timestamp";
import { ByteStream } from "./byte_stream";
export const id_certificateTransparency = "1.3.6.1.4.1.11129.2.4.2";
export class CertificateTransparency extends OctetString {
    constructor() {
        super(...arguments);
        this.items = [];
    }
    fromASN(asn) {
        super.fromASN(asn);
        const stream = new ByteStream(this.buffer);
        const len = stream.readNumber(2);
        this.items = [];
        while (stream.position < len) {
            this.items.push(new SignedCertificateTimestamp(stream));
        }
        return this;
    }
    toJSON() {
        return this.items.map((o) => o.toJSON());
    }
}
